import './ActionDialog.scss'

import ActionDialogBody from './ActionDialogBody'
import ActionDialogCancelButton from './ActionDialogCancelButton'
import ActionDialogDeleteButton from './ActionDialogDeleteButton'
import ActionDialogError from './ActionDialogError'
import ActionDialogFooter from './ActionDialogFooter'
import ActionDialogSaveButton from './ActionDialogSaveButton'
import ActionDialogWarning from './ActionDialogWarning'

export default class ActionDialog {
  public static Footer = ActionDialogFooter
  public static Body = ActionDialogBody
  public static CancelButton = ActionDialogCancelButton
  public static SaveButton = ActionDialogSaveButton
  public static DeleteButton = ActionDialogDeleteButton
  public static Error = ActionDialogError
  public static Warning = ActionDialogWarning
}
